<template>
  <table class="table table-striped table-bordered table-condensed">
    <thead>
      <tr>
        <th><div class="text-center">Name</div></th>
        <th><div class="text-center">Status</div></th>
        <th class="hidden-tablet"><div class="text-center">CPU(MHz)[Core]</div></th>
        <th><div class="text-center">Memory Usage</div></th>
        <th><div class="text-center">CPU Usage</div></th>
        <th class="hidden-tablet"><div class="text-center">IP address</div></th>
        <th><div class="text-center">VMs</div></th>
        <th class="hidden-tablet"><div class="text-center">Description</div></th>
        <th v-if="showActions"><div class="text-center">Commands</div></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in rows" :key="`hv-${row.id}`">
        <td><div class="text-center">{{ row.name }}</div></td>
        <td class="text-center">
          <span class="app-status-chip" :class="row.status_class">{{ row.status_label }}</span>
        </td>
        <td class="hidden-tablet">{{ row.cpu_label }}</td>
        <td>
          <div class="progress">
            <div class="progress-bar" :class="progressClass(row.mem_usage)" roll="progressbar" aria-valuemin="0" aria-valuemax="100" :style="{ width: `${row.mem_usage}%` }">
              <span style="display:none;">{{ row.mem_usage }}%</span>
            </div>
          </div>
        </td>
        <td>
          <div class="progress">
            <div class="progress-bar" :class="progressClass(row.cpu_usage)" roll="progress" aria-valuemin="0" aria-valuemax="100" :style="{ width: `${row.cpu_usage}%` }">
              <span style="display:none;">{{ row.cpu_usage }}%</span>
            </div>
          </div>
        </td>
        <td class="hidden-tablet">{{ row.ipaddress }}</td>
        <td>{{ row.vm_count_label }}</td>
        <td class="hidden-tablet">{{ row.description }}</td>
        <td v-if="showActions" class="hypervisor-actions-col" v-html="row.action_html"></td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ rows: [] })
  }
})

const rows = computed(() => props.initialData?.rows || [])
const showActions = computed(() => rows.value.some((row) => row.action_html))

function progressClass(value) {
  if (value <= 60) return 'progress-bar-info'
  if (value <= 80) return 'progress-bar-warning'
  return 'progress-bar-danger'
}
</script>
